module.exports = __webpack_public_path__ + "static/img/servicesbg5.8c1486b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/servicesbg5.jpg
// module id = UvO5
// module chunks = 1